import JustifyPanel from "./JustifyPanel";

const exportObjs = {
  Justify: JustifyPanel,
};

export default exportObjs;
